import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SocialForm extends Component {
  static = {
    icon: {
      vk: (
        <svg className="sm-icon" viewBox="0 0 20 20" width="20" height="20">
          <path d="M19.1 13.2c-.4-.5-.9-1-1.4-1.5l-.5-.5c-.2-.1-.3-.3-.3-.5s.1-.4.2-.5c.3-.4.5-.8.8-1.1l.7-1 .1-.1c.5-.7.9-1.4 1.2-2.2.1-.3.1-.6 0-.9-.2-.3-.5-.4-.8-.4h-3.3c-.5 0-.9.3-1.1.8-.2.4-.3.9-.6 1.3-.4 1-1 1.9-1.7 2.7l-.2.2c-.2-.2-.2-.4-.2-.6v-3.7c0-.6-.4-1.1-1-1.2h-3.3c-.4 0-.9.2-1.1.6-.2.1-.2.4-.2.6.1.2.3.3.5.4.3 0 .6.3.6.7.1.8.1 1.7 0 2.5l-.1.6v.1h-.1c-.3-.3-.5-.6-.6-.8-.8-1.1-1.4-2.3-1.8-3.5-.2-.5-.7-.8-1.2-.8h-2.8c-.3 0-.7.1-.9.4 0 .3 0 .7.1 1 1 2.3 2.2 4.5 3.6 6.6.7 1.1 1.7 2 2.8 2.7 1.1.7 2.4 1 3.7 1h.5c.9 0 1.2-.4 1.3-1.3 0-.4.1-.8.2-1.2l.1-.2c.1 0 .2 0 .2.1.2.1.3.2.4.4.1.1.2.3.4.4.2.3.5.6.8.9.5.6 1.3.9 2.1.9h2.8c.3 0 .6-.2.8-.5.2-.4.2-.8 0-1.2-.2-.5-.4-.9-.7-1.2z" />
        </svg>
      ),
    },
    capture: {
      vk: 'ВКонтакте',
    },
  };

  static propTypes = {
    active: PropTypes.bool,
    type: PropTypes.string.isRequired,
    url: PropTypes.string,
  };

  static defaultProps = {
    active: false,
  };

  onClick = e => {
    e.preventDefault();

    const { active, url } = this.props;

    if (active) {
      fetch(url).then(response => {
        location.reload();
      });
    } else {
      eval(url);
    }
  };

  render() {
    const { type, active } = this.props;
    const { icon, capture } = this.static;

    let classes = ['social-form', `type--${type}`];
    let txt = `${active ? 'Отвязать' : 'Привязать'} ${capture[type]}`;

    if (active) classes.push('social-form--active');

    return (
      <a className={classes.join(' ')} href="#" onClick={this.onClick}>
        {icon[type]}
        <span className="name">{txt}</span>
        <svg viewBox="0 0 14 14" width="10" height="10" className="act-icon">
          <path d="M12 5h-3v-3c0-1.1-.9-2-2-2s-2 .9-2 2v3h-3c-1.1 0-2 .9-2 2s.9 2 2 2h3v3c0 1.1.9 2 2 2s2-.9 2-2v-3h3c1.1 0 2-.9 2-2s-.9-2-2-2z" />
        </svg>
      </a>
    );
  }
}

export default SocialForm;
